import API_BASE_URL from '../config/baseUrl';

/**
 * Fetch downline users for a given parent
 * @param {number} userType - The user type of the downline users to fetch (1-7)
 * @param {string} parentId - The parent user ID
 * @param {string} accessToken - Bearer token for authentication
 * @param {number} noOfRecords - Number of records per page
 * @param {number} index - Page index
 * @param {boolean} forDeadClient - Filter for dead clients
 * @returns {Promise} API response
 */
export const fetchDownlineUsers = async (userType, parentId, accessToken, noOfRecords = 25, index = 0, forDeadClient = false) => {
  try {
    const response = await fetch(`${API_BASE_URL}/user/list-user-v2`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({
        userType: userType.toString(),
        parentId,
        noOfRecords,
        index,
        forDeadClient
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching downline users:', error);
    throw error;
  }
};

/**
 * Fetch user bet liability/exposure
 * @param {string} userId - The user ID to fetch exposure for
 * @param {string} accessToken - Bearer token for authentication
 * @returns {Promise} API response
 */
export const fetchUserExposure = async (userId, accessToken) => {
  try {
    const response = await fetch(`${API_BASE_URL}/ant-pro/get-user-bet-liability`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({
        userId
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching user exposure:', error);
    throw error;
  }
};